<template>
    <div>
        <v-text-field ref="formAddressSearch"
                      v-model="localAddress.address_1"
                      @change="updateAddress"
                      :label="'Address '+(required ? '*' : '')"
                      prepend-inner-icon="mdi-map-marker"
                      variant="outlined"
                      density="comfortable"></v-text-field>

        <v-text-field v-model="localAddress.address_2"
                      @change="updateAddress"
                      variant="outlined"
                      density="comfortable"></v-text-field>

        <v-text-field v-model="localAddress.suburb"
                      @change="updateAddress"
                      label="Suburb"
                      variant="outlined"
                      density="comfortable"></v-text-field>

        <v-row>
            <v-col>
                <v-text-field v-model="localAddress.city"
                              @change="updateAddress"
                              label="City"
                              variant="outlined"
                              density="comfortable"></v-text-field>
            </v-col>
            <v-col>
                <v-text-field v-model="localAddress.postcode"
                              @change="updateAddress"
                              label="Postcode"
                              variant="outlined"
                              density="comfortable"></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<style scoped>
</style>

<script>
    import { mapActions } from "vuex";

    export default {
        name: "AddressInput",
        data: function () {
            return {
                addressId: null,
                autocomplete: null,
                localAddress: {
                    address_1: '',
                    address_2: '',
                    suburb: '',
                    city: '',
                    postcode: '',
                    longitude: null,
                    latitude: null
                }
            };
        },
        mounted: function () {
            if (typeof this.address == 'undefined' || this.address == null) {
                this.$emit('update:address', this.localAddress);
            } else {
                this.addressId = this.address.id;
                this.localAddress = this.address;
            }

            // Wait for next tick to ensure the ref is available
            this.$nextTick(() => {
                // Access the actual input element from v-text-field
                const inputElement = this.$refs.formAddressSearch.$el.querySelector('input');
                // eslint-disable-next-line no-undef
                this.autocomplete = new google.maps.places.Autocomplete(inputElement, {
                    types: ["geocode"],
                    fields: ["address_component", "geometry"],
                    componentRestrictions: { country: 'nz' }
                });
                this.autocomplete.addListener('place_changed', this.loadAddress);
            });
        },
        props: {
            required: Boolean,
            address: Object,
        },
        methods: {
            ...mapActions([
                'showError'
            ]),
            loadAddress: function () {
                this.localAddress = this.loadGoogleAddress(this.autocomplete.getPlace());
                this.updateAddress();
            },
            updateAddress() {
                this.$emit('update:address', this.localAddress);
            },
            loadGoogleAddress: function (place) {
                // Load address
                var componentForm = {
                    'address_2': [''],
                    'suburb': ['sublocality_level_1'],
                    'city': ['locality', 'administrative_area_level_1'],
                    'postcode': ['postal_code'],
                };
                var address = {
                    address_1: '',
                    address_2: '',
                    suburb: '',
                    city: '',
                    postcode: '',
                    longitude: place.geometry.location.lng(),
                    latitude: place.geometry.location.lat()
                };
                var formIds = Object.keys(componentForm);
                var mapIds = Object.values(componentForm);
                // Add first address line
                var box = '';
                var number = '';
                var street = '';
                // Go through all components and attempt to load address
                for (var i = 0; i < place.address_components.length; i++) {
                    var types = place.address_components[i].types;
                    if (types.indexOf('subpremise') >= 0 && box == '') {
                        box = place.address_components[i]['long_name'];
                    }
                    if (types.indexOf('street_number') >= 0 && number == '') {
                        number = place.address_components[i]['long_name'];
                    }
                    if (types.indexOf('route') >= 0 && street == '') {
                        street = place.address_components[i]['long_name'];
                    }
                    for (var j = 0; j < types.length; j++) {
                        var type = types[j];
                        // Attempt to find type in array
                        for (var k = 0; k < mapIds.length; k++) {
                            var index = mapIds[k].indexOf(type);
                            // Do not populate if already has a value
                            if (index >= 0 && address[formIds[k]] == '') {
                                address[formIds[k]] = place.address_components[i]['long_name'];
                            }
                        }
                    }
                    address.address_1 = (box.length > 0 ? box + "/" : "") + number + " " + street;
                }
                return address;
            }
        },
        computed: {
        },
        watch: {
            address() {
                if (this.address) {
                    this.localAddress = this.address;
                    this.addressId = this.address.id;
                } else {
                    this.localAddress = {
                        address_1: '',
                        address_2: '',
                        suburb: '',
                        city: '',
                        postcode: '',
                        longitude: null,
                        latitude: null
                    };
                    this.addressId = null;
                }
            }
        }
    };
</script>